var map = {
	"./二维码图片.png": "a16d",
	"./公众号.jpg": "130d",
	"./公众号二维码.jpg": "2a78",
	"./公众号二维码1.png": "0410",
	"./加拿大.jpg": "65d8",
	"./加拿大站.png": "9925",
	"./客服.png": "4503",
	"./广告图1.jpg": "4e97",
	"./广告图2.jpg": "2b98",
	"./广告图一.jpg": "0233",
	"./广告图三.jpg": "06cb",
	"./广告图二.jpg": "5955",
	"./广告图五.jpg": "f0a9",
	"./广告图四.jpg": "34bb",
	"./微信.png": "f9b4",
	"./德国站.png": "2d0f",
	"./意大利站.png": "98b6",
	"./日本.jpg": "1ce4",
	"./日本站.png": "a40e",
	"./欧洲.jpg": "46ed",
	"./法国站.png": "2c52",
	"./澳洲.jpg": "6984",
	"./澳洲站.png": "6a04",
	"./电话.png": "bd1c",
	"./稿定设计-3.jpg": "583b",
	"./稿定设计-4.jpg": "099b",
	"./稿定设计-5.jpg": "b50b",
	"./稿定设计-6.jpg": "336e",
	"./美国.jpg": "afa4",
	"./美国站.png": "a4c2",
	"./英国.jpg": "8de9",
	"./英国站.png": "b0c9",
	"./西班牙站.png": "f24a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b697";